import { useMatch } from 'react-router-dom';

export const useUserDetailsFormMode = () => {
  const accountSettingsLocationMatchPath = useMatch('/settings/account');
  const createUserLocationMatchPath = useMatch('/settings/users/create');
  const editUserLocationMatchPath = useMatch('/settings/users/:userId/edit');

  return {
    isAccountSettingsMode: !!accountSettingsLocationMatchPath,
    isCreateUserMode: !!createUserLocationMatchPath,
    isEditUserMode: !!editUserLocationMatchPath,
  };
};
